import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectBasicInformationFromFormData } from "../selectors/collaborativeForm.selector";
import { generateCompositionFromBasicInfo } from "../utils/lib.js";

const FormSubmissionSuccess = () => {
  const navigate = useNavigate();

  const basicInformation = useSelector(selectBasicInformationFromFormData);
  
  const [searchParams] = useSearchParams();
  const submissionId = searchParams.get("id");

  // Sample material information (this would typically come from the form data)
  const materialInformation = [
    {
      vendor: basicInformation?.vendor?.defaultValue,
      fabricName: basicInformation?.fabricName?.defaultValue,
      vendorArticle: basicInformation?.vendorArticle?.defaultValue,
      composition: generateCompositionFromBasicInfo(Object.values(basicInformation || {})),
      material: basicInformation?.material?.defaultValue,
    },
  ];

  const handleGoBack = () => {
    navigate("/todo"); // Navigate back to main page or wherever appropriate
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
      }}
    >
      {/* Success Icon and Message */}
      <Box
        sx={{
          textAlign: "center",
          mb: 6,
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: "80px",
            color: "#4ade80",
            mb: 2,
          }}
        />
        <Typography
          variant="h3"
          sx={{
            fontSize: "32px",
            fontWeight: 600,
            color: "#333333",
            mb: 1,
          }}
        >
          Submission Successful
        </Typography>
        {submissionId && (
          <Typography
            variant="body2"
            sx={{
              color: "#666666",
              fontSize: "14px",
            }}
          >
            Submission ID: {submissionId}
          </Typography>
        )}
      </Box>

      {/* Material Information Table */}
      <Box sx={{ width: "100%", maxWidth: "800px", mb: 4 }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#333333",
            mb: 2,
          }}
        >
          Material Information
        </Typography>

        <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                <TableCell sx={{ fontWeight: 600, color: "#333333" }}>
                  Supplier
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: "#333333" }}>
                  Fabric Name
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: "#333333" }}>
                  Supplier Article #
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: "#333333" }}>
                  Composition
                </TableCell>
                {/* <TableCell sx={{ fontWeight: 600, color: "#333333" }}>
                  Material
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {materialInformation.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.vendor}</TableCell>
                  <TableCell>{item.fabricName}</TableCell>
                  <TableCell>{item.vendorArticle}</TableCell>
                  <TableCell>{item.composition}</TableCell>
                  {/* <TableCell>{item.material}</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Exit Button */}
      <Button
        variant="contained"
        onClick={handleGoBack}
        sx={{
          backgroundColor: "#4f46e5",
          color: "#ffffff",
          fontWeight: 600,
          fontSize: "16px",
          px: 4,
          py: 1.5,
          borderRadius: "8px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#4338ca",
          },
        }}
      >
        Exit
      </Button>
    </Box>
  );
};

export default FormSubmissionSuccess;
